import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {vignettePickerInsertForm_template} from "./vignettePickerInsertForm_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import { multipleSelector_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";

declare var ko: any;

export class vignettePicker_template extends vnTemplate {

    protected parent: any;
    protected target: any;
    public vignettePickerInsertForm_template: vignettePickerInsertForm_template;
    protected vignetteSearchFilter: filterSimple_template;
    protected ownerBrandFilter : multipleSelector_template;
    public vignettePagination: pagination_template;

    protected vignetteLoadEnable;
    protected vignetteNextPageRequested;

    protected getTemplateHtml(): string {

        return /* html */`
            <div class="w-lightbox w-picker article-picker" data-bind="css: { 'is-visible': isShown }" >

                <div class="lightbox-content picker" id="vignette-picker">

                    <div class="picker-header w-justify">

                        <div class="w-left">
                        </div>

                        <div class="w-center">
                            <span class="picker-header-title icon i-article">Vignette Search</span>
                        </div>

                        <div class="w-right">
                            <button type="button" class="close-btn icon i-close" data-bind="event: { click: onClickCancel }"></button>
                        </div>

                    </div>

                    <div class="picker-body">


                         <div class="list-header">
                            <div class="w-justify" style="margin-bottom: 1rem">
                                <div class="w-left" >
                                    ${ this.ownerBrandFilter.getHtmlBuild() }
                                </div>
                            </div>

                            <div class="w-justify" style="margin-bottom: 0">
                                <div class="w-center">
                                    ${this.vignetteSearchFilter.getHtmlBuild()}
                                </div>
                            </div>
                         </div>

                         <div class="selected-filters">
                            <div id="selected-ownerBrand"></div>
                        </div>

                        <div class="w-picker-list" id="vignette-results-list">

                            <div class="w-msg vignette" data-bind="css: { 'is-text-visible': vignettes().length == 0}">
                                <p>No Results Found</p>
                            </div>

                            <ul class="picker-list" id="vignette-picker-list" data-bind="foreach: vignettes">

                                <li class="picker-item icon">

                                    <button class="btn-zone view" title="view vignette" type="button" data-bind="event: { click: $parent.onClickView }" ><span>view vignette</span></button>

                                    <div class="w-info">
                                        <strong data-bind="text: name"></strong>
                                        <span data-bind="text: dateCreated"></span>
                                    </div>

                                </li>

                            </ul>

                        </div>
                    </div>

                    ${this.vignettePickerInsertForm_template.getHtmlBuild()}
                </div>
            </div>

            `;
    }

    protected getTemplateName(): string {
        return "vignettePicker_template-template";
    }

    protected buildViewModel(): any {

        //create observable array refresh function
        ko.observableArray.fn.refresh = function (item, index) {
            if (index==null) index = this['indexOf'](item);
            if (index >= 0) {
                this.splice(index, 1, ko.utils.extend({}, item)) 
            }
        }

        let huit_neuf_this = this;
        return {
            isShown: ko.observable(false),
            vignettes: ko.observableArray([]),
            selectedOwnerBrand: ko.observableArray([]),
            onClickCancel: function(data, event){ huit_neuf_this.onClickCancel();},
            onClickView: function(data, event){ huit_neuf_this.onClickView(data);},

        };
    }

    public getViewModelForRequest(){

        return {
            pagination: this.getTemplateViewModel().vignettePagination,
            filters      : {
                keyword: this.getTemplateViewModel().vignetteSearchFilter.filterKeyword,
                ownerBrandItems: this.getTemplateViewModel().ownerBrandFilter.selectedItems
            },
        }
    }

    protected initPartial(): void {

        this.vignetteSearchFilter = new filterSimple_template("vignetteSearchFilter", this.getTemplateViewModel(), this);
        this.vignetteSearchFilter.getTemplateViewModel().filterKeyword('');

        this.ownerBrandFilter = new multipleSelector_template("ownerBrandFilter", this.getTemplateViewModel(), this.caller);
        this.ownerBrandFilter.setLabel("owner brand");
        this.ownerBrandFilter.setFilterContainerClass('margin-neg');
        this.ownerBrandFilter.setTagContainerId('selected-ownerBrand');
        this.ownerBrandFilter.setTagContainerCaption('Selected owner brand:');

        this.vignettePickerInsertForm_template = new vignettePickerInsertForm_template("vignettePickerInsertForm_template", this.getTemplateViewModel(), this);
        this.vignettePickerInsertForm_template.setParent(this);
     
        this.vignettePagination = new pagination_template("vignettePagination", this.getTemplateViewModel(), this.caller);
        this.vignettePagination.getTemplateViewModel().itemPerPage = 54 ;
    }

    public setCaller(caller){
        this.caller = caller;
        this.vignetteSearchFilter.caller = caller;
        this.ownerBrandFilter.caller = caller;
        this.vignettePagination.caller = caller;
        if (typeof this.vignettePickerInsertForm_template.setCaller === 'function') {
            this.vignettePickerInsertForm_template.setCaller(caller);
        } else {
            this.vignettePickerInsertForm_template.caller = caller;
        }
        this.caller.getVignetteReferences();
    }

    public showVignettePicker(target): void {

        this.setTarget(target);
        this.show();
        this.fillPage();
        this.vignettePickerInsertForm_template.restPageValues();
        this.vignettePickerInsertForm_template.getTemplateViewModel().vignetteElement(null);
    }

    public setTarget(target){

        this.target = target;
    }

    public getTarget(){

        return this.target;
    }

    public show(){

        if(!document.body.classList.contains("is-fixed")){

            document.body.classList.add("is-fixed");
        }
        this.getTemplateViewModel().vignettes([]);
        this.resetPagination();
        this.getTemplateViewModel().isShown(true);
    }

    public hide(){

        document.body.classList.remove("is-fixed");
        this.getTemplateViewModel().isShown(false);
        // On close, cancel any tag filter pending requests and clear tag filter state
        if (this.caller && typeof this.caller.cancelTagFilterRequests === 'function') {
            this.caller.cancelTagFilterRequests();
        }
        if (this.vignettePickerInsertForm_template && typeof this.vignettePickerInsertForm_template.clearTagFilterState === 'function') {
            this.vignettePickerInsertForm_template.clearTagFilterState();
        }
    }

    public showLoading(){

        let list = document.getElementById("vignette-picker-list");
        list.classList.add("loading")
    }

    public hideLoading(){

        let list = document.getElementById("vignette-picker-list");
        list.classList.remove("loading")
    }

    public showFullLoading(){

        let list = document.getElementById("vignette-picker");
        list.classList.add("loading")
    }

    public hideFullLoading(){

        let list = document.getElementById("vignette-picker");
        list.classList.remove("loading")
    }

    public fillPage(){
        this.caller.getVignetteList();
    }

    public setVignettes(vignettes){

        if(this.getTemplateViewModel().vignettePagination.pageNumber == 1){
            this.getTemplateViewModel().vignettes([]);
        }
        if(vignettes.length > 0){
            let vignette = this.getTemplateViewModel().vignettes().concat(vignettes);
            this.getTemplateViewModel().vignettes(vignette);

            this.vignetteNextPageRequested = false;
            if (!this.vignetteLoadEnable) {
                this.enableVignettePickerWaypoint();
            }
        }
    }

    public setOwnerBrandFilterItems(brands){
        let ownerBrandItems = [];
        ownerBrandItems = brands.filter(b => b.isDeleted === 0).map(b => ({ id: b.id, name: b.name }));

        this.ownerBrandFilter.setItems(ownerBrandItems);
    }

    public setVignettePagination(totalPage, currentPage){

        this.getTemplateViewModel().vignettePagination.pageMax(totalPage);
        this.getTemplateViewModel().vignettePagination.pageNumber(currentPage);
    }

    public resetPagination(){

        this.getTemplateViewModel().vignettePagination.pageNumber(1);
        this.getTemplateViewModel().vignettePagination.pageMax(1);
        this.getTemplateViewModel().vignettes([]);
        this.vignetteLoadEnable = null;
    }

    public enableVignettePickerWaypoint() {

        var div = document.getElementById('vignette-results-list');
        let huit_neuf_this = this;

        var locked = false;
        var lastCall = 0;

        if(div) {
            div.addEventListener("scroll", function (event) {
                if(locked) return;

                if (lastCall) clearTimeout(lastCall);
                lastCall = setTimeout(() => {
                    if(huit_neuf_this) {
                        huit_neuf_this.runOnScroll(event, lastCall, locked, huit_neuf_this, div);
                    }
                }, 200);

                if (div && document.body.classList.contains("is-fixed") && div.scrollTop!= 0 && div.scrollTop + div.clientHeight >= (div.scrollHeight - 100) && !huit_neuf_this.vignetteNextPageRequested) {
                    if (huit_neuf_this.getTemplateViewModel().vignettePagination.pageNumber() < huit_neuf_this.getTemplateViewModel().vignettePagination.pageMax()) {
                        huit_neuf_this.getTemplateViewModel().vignettePagination.pageNumber(huit_neuf_this.getTemplateViewModel().vignettePagination.pageNumber() + 1)
                        huit_neuf_this.caller.getVignetteList();
                        huit_neuf_this.vignetteNextPageRequested = true;
                    }
                }

                locked = false;
            });
            this.vignetteLoadEnable = true;
        }
    }

    private runOnScroll(event, lastCall, locked, huit_neuf_this, div) {

        if(locked) return;

        if (lastCall) clearTimeout(lastCall);
        lastCall = setTimeout(() => {
            if(huit_neuf_this) {
                huit_neuf_this.runOnScroll(event, lastCall, locked, huit_neuf_this);
            }
        }, 200);

        locked = false;
    }

    protected onClickCancel(){

        this.hide();
        if(this.caller && typeof this.caller.cancelAndResetFetchRequest === 'function'){
            this.caller.cancelAndResetFetchRequest('getVignetteList');
        }
        if (this.caller && typeof this.caller.cancelTagFilterRequests === 'function') {
            this.caller.cancelTagFilterRequests();
        }
        if (this.vignettePickerInsertForm_template && typeof this.vignettePickerInsertForm_template.clearTagFilterState === 'function') {
            this.vignettePickerInsertForm_template.clearTagFilterState();
        }
    }

    public onClickView(data){
        if(data && data.id){
            this.showFullLoading();
            this.caller.getVignetteById(data.id);
        }
    }

    public showVignettePickerInsertForm(vignetteElement, target){
        this.setTarget(target);
        this.show();
        this.vignettePickerInsertForm_template.restPageValues();
        this.vignettePickerInsertForm_template.show();
        this.vignettePickerInsertForm_template.showLoading();
        
        let vignetteId =  vignetteElement.getAttribute('data-id');
        let variablesFromCard =  vignetteElement.getAttribute('data-variables');
        let referencesFromCard = vignetteElement.getAttribute('data-references');
        try {
            variablesFromCard = JSON.parse(variablesFromCard) || [];
        } catch (e) {
            console.error('Error parsing data-variables:', e);
            variablesFromCard = [];
        }
        try {
            referencesFromCard = JSON.parse(referencesFromCard) || { articles: [], tags: [], videos: [] };
        } catch (e) {
            console.error('Error parsing data-references:', e);
            referencesFromCard  = { articles: [], tags: [], videos: [] };
        }
        
        this.vignettePickerInsertForm_template.getTemplateViewModel().variablesFromCard(variablesFromCard);
        this.vignettePickerInsertForm_template.getTemplateViewModel().references(referencesFromCard);
        this.vignettePickerInsertForm_template.getTemplateViewModel().vignetteElement(vignetteElement);
        this.caller.getVignetteById(vignetteId);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/vignettePicker_template.ts